import affirm from '../Affirm'

class LoggerService {
    outputs: ILogOutputService[] = []

    register = async (service: ILogOutputService) => {
        affirm(this.outputs, 'Unassigned outputs in logging service')
        affirm(service, 'Invalid service passed to logger.register')
        affirm(service.id, 'Invalid id used for registering new logging output service')
        affirm(!this.outputs.some(x => x.id === service.id), 'Trying to register logging output service that was already registered')

        try {
            await service.init()
            this.outputs.push(service)
        } catch (error) {
            this.error(error)
        }
    }

    isRegistered = (id: string) => {
        affirm(this.outputs, 'Unassigned outputs in logging service')
        affirm(id, 'Invalid id used for checking if logging output service is registered')

        return this.outputs.some(x => x.id === id)
    }

    log = (text: string) => {
        this.outputs.forEach(x => x.log(text))
    }

    info = (text: string) => {
        this.outputs.forEach(x => x.info(text))
    }

    error = (error: Error | string | unknown) => {
        if (error instanceof Error) this.outputs.forEach(x => x.error(error))
        else if (typeof error === 'string') this.outputs.forEach(x => x.error(new Error(error)))
        else this.outputs.forEach(x => x.error(new Error(error as any)))
    }
}

const logger = new LoggerService()
export default logger

export interface ILogOutputService {
    id: string
    init: () => Promise<void>
    log: (text: string) => Promise<void>
    info: (text: string) => Promise<void>
    error: (error: Error) => Promise<void>
}
